import React from 'react';

class FilterDropdown extends React.Component {
    constructor(props){
        super(props)
    }
    onFilterPicked = (filter, index) => {
        this.props.onFilterPicked(filter, index)
    }
    onCloseFilters = () => {
        if (this.props.onCloseFilters){
            this.props.onCloseFilters()
        }
    }
    render(){
      
            return (
            
                    <div style={this.props.style} className="apps_dropdown filter_dropdown">
                        <div onClick={this.onCloseFilters} className="tooltip_bg"></div>
                        {this.props.filters.filter(f => !f.is_hide).map((filter, index) => (
                            <div onClick={() => this.onFilterPicked(filter, index)} className="flex apps_line" filter={filter} key={index}>
                                {filter.is_hide ? null : <p className="apps_drop_text">{filter.title_price ? filter.title_price : filter}</p>}
                            </div>   
                        ))}
                    </div>
            ); 
        
        
    }
}
export default FilterDropdown;
